const responder_a_solicitacao = [
  {
    path: "/responder-a-solicitacao",
    redirect: "",
    meta: {
      breadCrumb:
        "Gestão - Cadastrar as Solicitações de Serviços de uma Unidade para outra",
    },
    children: [
      {
        path: "/responder-a-solicitacao",
        name: "responder_a_solicitacao",
        component: () =>
          import("@/views/ResponderASolicitacao/ResponderASolicitacaoHome.vue"),
      },
      {
        path: "/responder-a-solicitacao/:id",
        name: "responder_a_solicitacao_editar",
        component: () =>
          import("@/views/ResponderASolicitacao/ResponderASolicitacaoEdit.vue"),
      },
    ],
  },
];

export { responder_a_solicitacao };
